import BaseBridge from '@/services/bridges/base';

interface IOpenPageParams {
  type: string;
  url: string;
  headerObj?: object;
  useHistoryBack: string;
  isSkipAuthAlert?: string;
}

interface IHandler {
  [key: string]: () => void;
}

class SktBridge extends BaseBridge {
  constructor(osType: string) {
    super(osType);
  }

  OPEN_OUT_LINK() {
    console.log('=== [ Bridges ] open out link', this.isIos);

    const params: IOpenPageParams = {
      type: 'O',
      url: '',
      useHistoryBack: 'N',
    };

    const handler: IHandler = {
      IOS: () => {
        window.webkit.messageHandlers.tauthJs.postMessage({
          method: 'openWebPage',
          args: {
            ...params,
          },
        });
      },
      AND: () => {
        window.tauthJs['openWebPage'](JSON.stringify(params));
      },
    };

    handler[this.osType]();
  }

  OPEN_WEB_VIEW() {
    console.log('=== [ Bridges ] open web view');
  }

  CLOSE() {
    console.log('=== [ Bridges ] web view close');
  }
}

export default SktBridge;
